import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefresh = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M23.533 8.467c-2.173-2.173-5.253-3.427-8.64-3.080-4.893 0.493-8.92 4.467-9.467 9.36-0.733 6.467 4.267 11.92 10.573 11.92 4.253 0 7.907-2.493 9.613-6.080 0.427-0.893-0.213-1.92-1.2-1.92-0.493 0-0.96 0.267-1.173 0.707-1.507 3.24-5.12 5.293-9.067 4.413-2.96-0.653-5.347-3.067-5.973-6.027-1.12-5.173 2.813-9.76 7.8-9.76 2.213 0 4.187 0.92 5.627 2.373l-2.013 2.013c-0.84 0.84-0.253 2.28 0.933 2.28h4.787c0.733 0 1.333-0.6 1.333-1.333v-4.787c0-1.187-1.44-1.787-2.28-0.947l-0.853 0.867z" })
});
export default SvgRefresh;
